
import components.*
import pages.home.*

import kotlinx.html.dom.*
import kotlinx.browser.*
import kotlinx.html.js.*
import kotlinx.html.js.style

import kotlinx.browser.document
import kotlinx.html.style
import pages.projects.projectsPage

fun main() {
    window.onload = {

        document.head?.append{

            style {
                +"div.main { background-color: rgba(100, 125, 125, 0.15); position: relative; top: 5em; box-shadow: inset .8px .8px 0.8px 3px rgba(0,0,0,0.1); padding: 4px; margin: 5px; } "
            }





        }

        document.body?.append {

            myHeader()



val navPage = let {
   val s = window.location.href.split("#")
   if(s.size == 1)
      ""
   else
      s[1]

}


            when (navPage){
                "Projects" -> projectsPage()
                "" -> homePage()
               else -> homePage()

            }
        }


    }
}






